import React, { PropsWithChildren } from 'react';

import { useAppDispatchUserStatus } from '../../app/AppDispatcher';
import { AppHeader } from '../app_header/AppHeader';

export function UserViewBase({ children }: PropsWithChildren) {
  // console.log(`Login userStatus: ${userStatus}`);
  useAppDispatchUserStatus();

  return (
    <div className="App">
      <AppHeader />
      {children}
    </div>
  );
}
